import { useContext, useEffect, useState } from "react";
import "./style.css";
import { getDataFromApi } from "../../APIs";
import EventSlider from "../../components/EventSlider";
import SectionTitle from "../../components/SectionTitle";
import { faBookmark, faCalendar } from "@fortawesome/free-solid-svg-icons";
import EventCard from "../../components/EventCard";
import ExploreButton from "../../components/ExploreButton";
import {
  COOKIES_EXPIRY_TIME,
  GETMORESPORTINGEVENT_API,
  POPULAREVENT_API,
  POPULARTEAMS_API,
  UPCOMINGEVENT_API,
} from "../../constants";
import TeamCardBox from "../../components/TeamCardBox";
import HomeImageContent from "../../components/HomeImageContent";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { filterDataContext } from "../../App";
import { competitionData } from "../../constants/TextContainer";
import { EVENTSPAGE } from "../../constants/RoutingPath";
import EventCardLoader from "../../components/Loaders/Home/EventCard";
import TeamCardLoader from "../../components/Loaders/Home/TeamCard";
import { ChangeSportTypeforApi } from "../../utils/func";
import { useCookies } from "react-cookie";

const HomePage = () => {
  const { selectedSport, moreEvents, setMoreEvents, preloadTeams, profileDetail, setProfileDetail } =
    useContext(filterDataContext);
  const [popularEvents, setPopularEvent] = useState([]);
  const [upcomingEvents, setUpcominEvent] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [popularTeams, setPopularTeams] = useState([]);
  const [popularTeamLoader, setPopularTeamLoader] = useState(false);
  const [moreSportEventsLoader, setMoreSportsEventsLoader] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies([]);

  const navigate = useNavigate();

  const getAndSetData = async (url) => {
    let response = await getDataFromApi(url);
    if (response) {
      return response.data.data;
    }
  };


  useEffect(() => {
    let sport_Type = searchParams.get("sport_type");
    let trpToken = searchParams.get("token")
    if (trpToken) {
      setCookie(process.env.REACT_APP_API_TOKEN, trpToken, {
        maxAge: COOKIES_EXPIRY_TIME,
        path: "/",
      });
    }
    if (!sport_Type) {
      setSearchParams({ sport_type: "football" });
    }
  }, []);

  useEffect(() => {
    const load = async () => {
      if (selectedSport) {
        let popularEvents = await getAndSetData(
          `${POPULAREVENT_API}&sport_type=${selectedSport}`
        );
        if (popularEvents) {
          setPopularEvent(popularEvents);
        }
        let upcomingEvents = await getAndSetData(
          `${UPCOMINGEVENT_API}&sport_type=${selectedSport}`
        );
        if (upcomingEvents) {
          setUpcominEvent(upcomingEvents);
        }
      }
    };
    load();
  }, [selectedSport]);

  const getMoreSportsEvents = async () => {
    setMoreSportsEventsLoader(true);
    let moreSportsEvents = await getAndSetData(GETMORESPORTINGEVENT_API);
    if (moreSportsEvents) {
      setMoreEvents(moreSportsEvents);
    }
    setMoreSportsEventsLoader(false);
  };

  useEffect(() => {
    if (moreEvents.length === 0) {
      getMoreSportsEvents();
    }
  }, []);

  const getPopularTeams = async () => {
    let popularTeamsData;
    setPopularTeamLoader(true);
    if (preloadTeams?.length === 0) {
      popularTeamsData = await getAndSetData(
        `${POPULARTEAMS_API}&sport_type=${selectedSport}`
      );
    } else {
      popularTeamsData = preloadTeams?.filter(
        (item) =>
          item.sport_type === ChangeSportTypeforApi(selectedSport) &&
          item.popular_team === 1
      );
    }
    if (popularTeamsData) {
      let returnedData = popularTeamsData?.slice(0, 4).map((item, index) => {
        if (index == 0) {
          item.class = "one";
        }
        if (index == 1) {
          item.class = "two";
        }
        if (index == 2) {
          item.class = "three";
        }
        if (index == 3) {
          item.class = "four";
        }
        return item;
      });
      setPopularTeams(returnedData);
      setPopularTeamLoader(false);
    }
  };

  useEffect(() => {
    if (selectedSport) {
      getPopularTeams();
    }
  }, [selectedSport]);

  const getTeamEvents = (teamName, teamSport) => {
    navigate({
      pathname: EVENTSPAGE,
      search: createSearchParams({
        sport_type:
          teamSport === "soccer"
            ? "football"
            : teamSport === "soccer"
              ? "formula1"
              : teamSport,
        team_name: teamName,
      }).toString(),
    });
  };

  const navigateToEvents = (sportType) => {
    navigate(`${EVENTSPAGE}?sport_type=${sportType}`)
  }

  return (
    <div>
      <HomeImageContent />
      <section className="pop_competition_team">
        <div className="events_container">
          <div className="competitions_sec">
            <SectionTitle title={"Competitions"} icon={faBookmark} />
            <div className="competition_card">
              {competitionData?.map((item, index) => (
                <TeamCardBox rdBox item={item} key={index} navigateToEvents={navigateToEvents} />
              ))}
            </div>
          </div>
          {popularTeamLoader ? (
            <div className="popularTeams_sec">
              <SectionTitle title={"POPULAR TEAMS"} icon={faBookmark} />
              <div className="popularTeam_card">
                <TeamCardLoader />
                <TeamCardLoader />
                <TeamCardLoader />
                <TeamCardLoader />
              </div>
            </div>
          ) : (
            popularTeams.length > 0 && (
              <div className="popularTeams_sec">
                <SectionTitle title={"POPULAR TEAMS"} icon={faBookmark} />
                <div className="popularTeam_card">
                  {popularTeams?.slice(0, 4).map((item, index) => (
                    <TeamCardBox
                      item={item}
                      key={index}
                      getTeamEvents={getTeamEvents}
                    />
                  ))}
                </div>
              </div>
            )
          )}
        </div>
      </section>
      <section
        className="events_body"
        style={{
          display:
            popularEvents.length === 0 && upcomingEvents.length === 0
              ? "none"
              : "",
        }}
      >
        <div className="events_container">
          {popularEvents?.length > 0 && (
            <>
              <SectionTitle title={"POPULAR EVENTS"} icon={faBookmark} />
              <div
                className={`slider_sec ${popularEvents.length > 3 ? "active" : ""
                  }`}
              >
                <div className="inner_slide_sec">
                  <EventSlider dataX={popularEvents} />
                </div>
              </div>
            </>
          )}

          {upcomingEvents?.length > 0 && (
            <>
              <SectionTitle title={"UPCOMING EVENTS"} icon={faCalendar} />
              <div
                className={`slider_sec ${upcomingEvents.length > 3 ? "active" : ""
                  }`}
              >
                <div className="inner_slide_sec">
                  <EventSlider dataX={upcomingEvents} />
                </div>
              </div>
            </>
          )}
        </div>
      </section>

      <section className="more_events_sec">
        <div className="">
          <div className="more_headers">
            <h3>More Sporting events</h3>
            <p>
              See what is available for many of the best sporting events on the
              planet. Choose the sport below or following the button to see all
              available sporting events.
            </p>
          </div>
          <div className="more_event_body">
            <div className="more_cards events_container">
              {moreSportEventsLoader === true ? (
                <>
                  <div className="min_Cards">
                    <EventCardLoader />
                  </div>
                  <div className="min_Cards">
                    <EventCardLoader />
                  </div>
                </>
              ) : (
                moreEvents?.map((item, index) => {
                  return (
                    <div className="min_Cards" key={index}>
                      <EventCard key={index} CardData={item} />
                    </div>
                  );
                })
              )}
            </div>
            {/* <div className="explore">
              <ExploreButton />
            </div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
